export default __webpack_public_path__ + "locales/nl/DeleteThirdPartyDialog.json?hash=c15f4ca22900162b26c2128792e926ec";